import submitCommand from '../../../services/submitCommand';
import uuid from '../../../services/uuid';

export const joinOrViaMembershipCode = (
  userId: string,
  email: string,
  firstName: string,
  lastName: string,
  prefix: string,
  suffix: string
) => {
  const id = uuid.generate();
  const cmd = {
    id: id,
    userId: {
      id: userId,
    },
    email: email,
    firstName: firstName,
    lastName: lastName,
    code: {
      prefix: prefix,
      suffix: suffix,
      _type: 'MembershipCode',
    },
    initiatingUserId: userId,
  };
  return submitCommand(id, cmd, 'RedeemCode', 'CodeRedeemed', [
    'RedeemCodeSagaError',
    'MembershipCodeDoesNotExist',
    'MembershipCodeFull',
    'MembershipCodeExpired',
    'MembershipCodeIsInactive',
    'MembershipCodeAlreadyRedeemedForUser',
  ]);
};
